import { Component, inject, input, output, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ReportControl } from '@xmedical/core';

@Component({
  selector: 'xmed-section-title-renderer',
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule
  ],
  providers: [DatePipe],
  templateUrl: './section-title-renderer.component.html',
  styleUrl: './section-title-renderer.component.scss'
})
export class SectionTitleRendererComponent implements OnInit {
  private datePipe = inject(DatePipe);

  control = input.required<ReportControl>();
  value: Date = new Date();

  valueChanged = output<void>();

  ngOnInit(): void {
    const ctrl = this.control();
    if (ctrl?.titleDateValue !== '') {
      this.value = new Date(ctrl.titleDateValue);
    } else {
      this.value = new Date();
      ctrl.titleDateValue = this.dateFormatter(this.value);
      this.valueChanged.emit();
    }
  }

  onValueChanges(date: Date): void {
    this.control().titleDateValue = this.dateFormatter(date);
    this.valueChanged.emit();
  }

  private dateFormatter(date: Date): string {
    return this.datePipe.transform(date, 'yyyy-MM-dd') ?? '';
  }
}
